import ControlFactory from '@/Factories/ControlFactory';
import ComponentManager from '@/Management/ComponentManager';
import RADApplication from '@/Management/RADApplication';
import * as NumericTypeHelper from '@/Utility/NumericTypeHelper';
import EnhancedTabGroupBoxViewModelT from '@/ViewModels/Controls/EnhancedTabGroupBoxViewModel';
import EnhancedTabGroupBoxT from '@/Controls/EnhancedTabGroupBox';

export default class EnhancedTabGroupBoxFactory extends ControlFactory {
    private controlHtmlElement: JQuery;
    private EnhancedTabGroupBoxViewModel = ComponentManager.getViewModel<typeof EnhancedTabGroupBoxViewModelT>('EnhancedTabGroupBoxViewModel');
    private EnhancedTabGroupBox = ComponentManager.getControl<typeof EnhancedTabGroupBoxT>('EnhancedTabGroupBox');

    public constructor(private params: any) {
        super(params);
    }

    public getControl(): JQuery {
        if (this.controlHtmlElement != null) {
            return this.controlHtmlElement;
        }

        this.viewModel = new this.EnhancedTabGroupBoxViewModel({
        });
        this.control = new this.EnhancedTabGroupBox(this.viewModel as EnhancedTabGroupBoxViewModelT);

        let tuple = this.control.getTuple();
        this.controlHtmlElement = tuple.control;
        
        return this.controlHtmlElement;
    };
}

ComponentManager.setFactory('EnhancedTabGroupBoxFactory', EnhancedTabGroupBoxFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');